import React from 'react';
import styles from './FooterLinks.css';

const PMDurl = 'https://www.fda.gov/forconsumers/consumerupdates/ucm101653.htm';
const RHAurl =
  'https://d2gdm6lfmduyqo.cloudfront.net/documents/covetrus/RyanHaight.pdf';

const FooterLinks = () => ({
  render() {
    return (
      <div className={styles.footerLinks}>
        <a className={styles.footerBoldLink} href="/about">
          ABOUT US
        </a>
        <a className={styles.footerBoldLink} href="/contact">
          CONTACT US
        </a>
        <a className={styles.footerLinkItem} href="/policies">
          Our Policies
        </a>
        <a
          className={styles.footerLinkItem}
          target="_blank"
          href={PMDurl}
          rel="noreferrer"
        >
          Proper Medication Disposal
        </a>
        <a
          className={styles.footerLinkItem}
          target="_blank"
          href={RHAurl}
          rel="noreferrer"
        >
          Ryan Haight Act
        </a>
      </div>
    );
  },
});

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/components/FooterLinks.jsx